import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { Row, Card } from "antd";
import styled from "themes/styled";
import { useTheme } from "themes/useTheme";
import WhiteSpace from "../WhiteSpace";
import useSizeMediaQuery from "hooks/useSizeMediaQuery";
import Box from "../Box";
import { useFullscreen } from "components/AppConfig/hooks";
import { FullscreenExitOutlined, FullscreenOutlined } from "@ant-design/icons";
import { isString } from "lodash";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

interface IProps {
  delay?: number;
  fullscreen?: boolean;
  title?: string;
  filter?: boolean;
  picker?: boolean;
}

const PageSkeleton = (props: IProps) => {
  const { title, filter = false, picker = false } = props;
  const { themeVariables } = useTheme();

  const size = useSizeMediaQuery();

  const [fullScreen, setFullScreen] = useFullscreen();

  const isSmall = size === "xs";

  const { t } = useTranslation();

  const translatedTitle = isString(title) ? t(title as any) : undefined;

  return (
    <>
      <Helmet>{translatedTitle && <title>{translatedTitle}</title>}</Helmet>
      <Container
        {...(fullScreen
          ? {
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 1000,
              backgroundColor: themeVariables.base_color,
            }
          : {})}
      >
        <div
          style={{
            paddingTop: themeVariables.spacing_md,
            paddingLeft: themeVariables.spacing_lg,
            paddingRight: themeVariables.spacing_lg,
          }}
        >
          <Row align="middle" justify="space-between" style={{ height: 30 }}>
            {title ? (
              <Title>{isString(title) ? translatedTitle : title}</Title>
            ) : (
              <Skeleton width={100} height={18} />
            )}
            {!fullScreen ? (
              <FullscreenOutlined
                style={{ fontSize: 18 }}
                onClick={() => {
                  setFullScreen(true);
                }}
              />
            ) : (
              <FullscreenExitOutlined
                style={{ fontSize: 18 }}
                onClick={() => setFullScreen(false)}
              />
            )}
          </Row>
        </div>
        {isSmall && <WhiteSpace />}
        <Content small={isSmall}>
          {picker && (
            <>
              <Card size="small" bordered={false} style={{ height: 52 }}>
                <Skeleton width={"100%"} height={24} />
              </Card>
              <WhiteSpace />
            </>
          )}
          {filter && (
            <>
              <Card size="small" bordered={false} style={{ height: 74 }}>
                <Skeleton width={"100%"} height={45} />
              </Card>
              <WhiteSpace />
            </>
          )}

          <Card size="small" bordered={false} style={{ height: "80vh" }}>
            <Skeleton width={"100%"} height={"calc(80vh - 30px)"} />
          </Card>
        </Content>
      </Container>
    </>
  );
};

const Container = styled(Box)`
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.base_color}px;
`;

const Content = styled.div<{ small: boolean }>`
  margin: ${(props) => (props.small ? 0 : props.theme.spacing_md)}px;
`;

export const Title = styled.h3`
  margin: 0px;
  font-size: 16px;
`;

export default PageSkeleton;
